import { DEFAULT_LOCALE, type SupportedLocale } from './localization';

export type ClientLocale = SupportedLocale;

export function resolveClientLocale(value: unknown): ClientLocale {
  return value === 'en' || value === 'es' ? value : DEFAULT_LOCALE;
}

export function clientIntlLocale(locale: ClientLocale): string {
  return locale === 'es' ? 'es-ES' : 'en-US';
}

export function formatClientCurrency(
  amount: number | null | undefined,
  locale: ClientLocale,
  currency = 'USD'
) {
  return new Intl.NumberFormat(clientIntlLocale(locale), {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(amount ?? 0);
}

export function formatClientDate(value: string | null | undefined, locale: ClientLocale) {
  if (!value) return locale === 'es' ? '—' : 'N/A';
  return new Date(value).toLocaleDateString(clientIntlLocale(locale), {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}
